import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-alphabet-quickSearch',
  standalone: true,
  templateUrl: './alphabetQuickSearch.html',
  styleUrl: './alphabetQuickSearch.css',
})
export class AlphabetQuickSearch {
  @Output() letterSelected = new EventEmitter<string>();

  filterByLetter(event: Event, letter: string): void {
    event.preventDefault();
    this.letterSelected.emit(letter);
  }
}
